import React from "react";
import "./Footer.css";
import CMS from "../cms.json";

const footer = CMS.footer || {};
const footerLinks = footer.columns || [];
const tagline = footer.tagline || "Prague-based cinematic rock band";
const copyrightYear = footer.copyrightYear || "2025";
const logoSrc = footer.logoSrc || CMS.navbar?.logoSrc || "/images/logos/logohorizontal.png";

const Footer = () => {
  return (
    <footer className="footer-section">
      <div className="footer-container">
        <div className="footer-logo-section">
          <div className="footer-logo">
            <img src={logoSrc} alt="The Creaks Logo" className="footer-logo-image" />
          </div>
          <p className="footer-tagline">{tagline}</p>
        </div>

        <div className="footer-links-section">
          {footerLinks.map((column, index) => (
            <div key={index} className="footer-column">
              <h3 className="footer-column-title">{column.title}</h3>
              <ul className="footer-links-list">
                {(column.links || []).map((link, linkIndex) => (
                  <li key={linkIndex} className="footer-link-item">
                    <a
                      href={link.url}
                      className="footer-link"
                      target={link.url.startsWith("http") ? "_blank" : "_self"}
                      rel={link.url.startsWith("http") ? "noopener noreferrer" : ""}
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="footer-bottom">
        <p className="footer-copyright">© {copyrightYear} The Creaks. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
